enum WorkResourceEnum {
    tool, personalProtectiveEquipment
}

export default WorkResourceEnum;